const ELEVATE_BADGE_LOCATIONS = {
  primary: 'TOP_LEFT',
  secondary: 'TOP_LEFT'
};

export const getElevateBadges = product => {
  const badges = product?.typedCustom?.json?.badgedata;

  if (!badges) return [];

  return badges;
};
